export * from './stack/stack.component';
export * from './stack/stack.module';

export * from './touch-animation/touch-animation.directive';
export * from './touch-animation/touch-animation.module';



// WEBPACK FOOTER //
// /home/travis/build/RaphaelYan/ngx-deck/src/index.ts